import { isValid, parse, parseISO } from 'date-fns'

/**
 * Parse the date part of a UTC date string with this format "YYYY-MM-DD'T'00:00:00Z"
 * and ignores the time part to prevent a date shift during the conversion.
 */
export const parseDateOnlyFromDateTimeIso = (dateString: string): Date | null => {
    if (!dateString) return null

    const date = parse(dateString.slice(0, 10), 'yyyy-MM-dd', new Date())
    if (!isValid(date)) return null

    date.setHours(0)
    date.setMinutes(0)
    date.setSeconds(0)
    date.setMilliseconds(0)

    return date
}

/**
 * Parses a date string to a local midnight Date, regardless of timezone.
 * Handles both date-only ("2026-04-16") and full ISO datetime strings
 * ("2026-04-16T00:00:00.000Z") without introducing UTC day shifts.
 */
export const parseLocalDate = (dateString: string): Date | null => {
    const parsed = parseISO(dateString)
    if (!isValid(parsed)) return null

    return new Date(parsed.getFullYear(), parsed.getMonth(), parsed.getDate())
}

export const parseLocalDateTimeOrDateOnly = (
    dateString: string,
    timeNotDefined: boolean | undefined
): Date | null =>
    timeNotDefined ? parseDateOnlyFromDateTimeIso(dateString) : parseLocalDate(dateString)
